import React, { Fragment, useState } from 'react';
import { Card, Form } from "react-bootstrap";
import { IoTrash } from 'react-icons/io5';
import useMyAddress from '../../Hooks/MyProfile/useMyAddress';
import OrderSummary from '../Cart/OrderSummary';
import Loader from '../Main/Loader';
import useCheckout from '../../Hooks/Checkout/useCheckout';

const CheckoutScreen = () => {

    const {
        selectedAddress,
        setSelectedAddress,
        isAddnewAddress,
        isLoading,
        allAddress,
        hanldeAddressLine1,
        hanldeAddressLine2,
        hanldeCity,
        hanldeState,
        hanldeCountry,
        hanldeZip,
        handleSubmit,
        handleDeleteAddress,
        setIsAddnewAddress,
        addressLine1,
        addressLine2,
        city,
        state,
        country,
        zip,
        handleEdit,
    } = useMyAddress();


    const {
        addressId,
        handleAddressId,
        handlePayNow
    } = useCheckout();





    const [newAddress, setNewAddress] = useState("newAddress")
    // const [selectedAddress, setSelectedAddress] = useState("address1");

    console.log(addressId)

    return (
        <Fragment>

            <div className="container my-5">

                <div className="row justify-content-between">
                    <div className="col-lg-6">
                        <h5 className='mb-4 d-none'>Billing Detail</h5>

                        <Form className='row d-none'>
                            <Form.Group className="mb-3 col-lg-6" controlId="formBasicEmail">
                                <Form.Control type="text" className='border-0' placeholder="First Name" />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-6" controlId="formBasicEmail">
                                <Form.Control type="text" className='border-0' placeholder="Last Name" />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-6" controlId="formBasicEmail">
                                <Form.Control type="Email" className='border-0' placeholder="Email" />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-6" controlId="formBasicEmail">
                                <Form.Control type="text" className='border-0' placeholder="Phone" />
                            </Form.Group>


                        </Form>


                        <div className="row d-none" >
                            <div className="col">
                                <h5 className='mb-4'>Shipping Detail</h5>
                            </div>
                            <div className="col-auto">
                                <Form.Group className="mb-3" controlId="formBasicCheckbox">
                                    <Form.Check type="checkbox" label="Same as billing detail" />
                                </Form.Group>
                            </div>
                        </div>

                        <Form className='row d-none'>
                            <Form.Group className="mb-3 col-lg-6" controlId="formBasicEmail">
                                <Form.Control type="text" className='border-0' placeholder="First Name" />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-6" controlId="formBasicEmail">
                                <Form.Control type="text" className='border-0' placeholder="Last Name" />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-6" controlId="formBasicEmail">
                                <Form.Control type="Email" className='border-0' placeholder="Email" />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-6" controlId="formBasicEmail">
                                <Form.Control type="text" className='border-0' placeholder="Phone" />
                            </Form.Group>


                        </Form>



                        <div className="row">
                            <div className="col">
                                <h5 className='mb-4'>Add Address</h5>
                            </div>
                            <div className="col-auto">
                                <Form.Check
                                    inline
                                    label="Saved Address"
                                    name="group1"
                                    type="radio"
                                    value="savedAddress"
                                    onChange={(e) => setNewAddress(e.target.value)}
                                    checked={newAddress === "savedAddress"}
                                />
                                <Form.Check
                                    inline
                                    label="Add New Address"
                                    name="group1"
                                    type="radio"
                                    value="newAddress"
                                    onChange={(e) => setNewAddress(e.target.value)}
                                    checked={newAddress === "newAddress"}
                                />
                            </div>

                        </div>


                        {
                            newAddress === "newAddress" ? (
                                <>
                                    <Form className='row'>
                                        <Form.Group className="mb-3 col-lg-12" controlId="formBasicEmail">
                                            <Form.Control type="text" className='border-0' placeholder="Address Line 1" />
                                        </Form.Group>
                                        <Form.Group className="mb-3 col-lg-12" controlId="formBasicEmail">
                                            <Form.Control type="text" className='border-0' placeholder="Address Line 2" />
                                        </Form.Group>
                                        <Form.Group className="mb-3 col-lg-6" controlId="formBasicEmail">
                                            <Form.Control type="text" className='border-0' placeholder="First Name" />
                                        </Form.Group>
                                        <Form.Group className="mb-3 col-lg-6" controlId="formBasicEmail">
                                            <Form.Control type="text" className='border-0' placeholder="Last Name" />
                                        </Form.Group>
                                        <Form.Group className="mb-3 col-lg-6" controlId="formBasicEmail">
                                            <Form.Control type="Email" className='border-0' placeholder="Email" />
                                        </Form.Group>
                                        <Form.Group className="mb-3 col-lg-6" controlId="formBasicEmail">
                                            <Form.Control type="text" className='border-0' placeholder="Phone" />
                                        </Form.Group>


                                    </Form>
                                </>
                            ) :
                                (
                                    <>
                                        {
                                            Array.isArray(allAddress) && allAddress?.length > 0 ? (
                                                allAddress.map((address, index) => (
                                                    <Card
                                                        key={address}
                                                        className={`mb-3 bg-light border-0 ${selectedAddress === address ? "border-primary" : ""}`}
                                                    >
                                                        <Card.Body className="d-flex align-items-start">
                                                            <Form.Check
                                                                type="radio"
                                                                name="address"
                                                                id={address}
                                                                checked={addressId === address?.id}
                                                                onChange={() => handleAddressId(address?.id)}
                                                                className="me-2"
                                                            />
                                                            <div className="col-auto verticle-border-70 ms-3" />

                                                            <div className='ms-4 w-100'>

                                                                <div className="row">
                                                                    <div className="col">
                                                                        <Card.Title className='fw-500'>{`Address ${index + 1}`}</Card.Title>

                                                                    </div>
                                                                    <div className="col-auto d-flex d-none">
                                                                        <p className='me-2 text-danger fw-600 mb-0 s-14 cursor-pointer' onClick={() => setIsAddnewAddress("editAddress")}>Edit</p>

                                                                        <div className="verticle-border" />

                                                                        <p className='ms-2 s-14 mb-0 text-muted'>Set As Default</p>
                                                                    </div>
                                                                </div>
                                                                <Card.Text>
                                                                    {address?.street}

                                                                    <p className='mb-0 text-danger text-end d-none'>

                                                                        {
                                                                            isLoading ? <Loader /> :
                                                                                <>
                                                                                    <IoTrash className='cursor-pointer' size={18} onClick={() => { handleDeleteAddress(address?.id) }} />

                                                                                </>
                                                                        }
                                                                    </p>

                                                                </Card.Text>
                                                            </div>
                                                        </Card.Body>
                                                    </Card>
                                                ))
                                            ) : ("No Address")

                                        }
                                    </>
                                )
                        }



                        <hr />

                        <div className="col-auto">
                            <Form.Group className="mb-3" controlId="formBasicCheckbox">
                                <Form.Check type="checkbox" label="By Clicking, you agree to our Terms & conditions and Privacy Policy" />
                            </Form.Group>
                        </div>


                    </div>

                    <div className="col-lg-4">
                        <div>
                            <OrderSummary />
                        </div>




                    </div>


                </div>

            </div>




        </Fragment >
    )
}

export default CheckoutScreen